<template>
  <nav
    class="breadcrumbs"
    :aria-label="$string('general.breadcrumbs.label')"
  >
    <ol class="breadcrumbs__list-element">
      <li class="breadcrumbs__list-item">
        <a
          class="breadcrumbs__link text-button-m"
          :href="$variable('routes.root')"
          v-text="$string('general.breadcrumbs.home')"
        />

        <span
          class="breadcrumbs__separator"
          aria-hidden="true"
        />
      </li>

      <li
        v-if="hasAncestor || hasBackup"
        class="breadcrumbs__list-item"
      >
        <a
          class="breadcrumbs__link text-button-m"
          :href="ancestorUrl || backupUrl"
          v-text="ancestorTitle || backupTitle"
        />

        <span
          class="breadcrumbs__separator"
          aria-hidden="true"
        />
      </li>

      <li class="breadcrumbs__list-item">
        <span
          class="breadcrumbs__link text-button-m"
          v-text="title"
        />
      </li>
    </ol>
  </nav>
</template>

<script>

/**
 * Vue: Breadcrumbs (breadcrumbs)
 * -----------------------------------------------------------------------------
 * Breadcrumbs navigation links.
 *
 * @param {String} ancestorTitle - Title of ancestor, e.g. collection title if
 * product is in a collection.
 * @param {String} ancestorUrl - URL of ancestor, this avoids complicating the
 * breadcrumb component by making additional queries to load ancestor data.
 * @param {String} state - Loading state of parent component.
 * @param {String} title - Title displayed for current page.
 *
 */

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Breadcrumbs',

  props: {
    ancestorTitle: {
      type: String,
      default: '',
    },
    ancestorUrl: {
      type: String,
      default: '',
    },
    backupTitle: {
      type: String,
      default: '',
    },
    backupUrl: {
      type: String,
      default: '',
    },
    // state: {
    //   type: String,
    //   default: 'loading',
    // },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {

    /**
     * Check if ancestor exists
     * @returns {Boolean}
     */
    hasAncestor() {
      return this.ancestorTitle && this.ancestorUrl
    },

    /**
     * Check if backup collection exists
     * @returns {Boolean}
     */
    hasBackup() {
      return this.backupTitle && this.backupUrl
    },
  },
}
</script>

<style lang="scss">
@import './breadcrumbs';
</style>
